import styles from './Alert.module.css';
import { X } from 'lucide-react';

export interface AlertProps {
    type?: 'info' | 'success' | 'warning' | 'error';
    title?: string;
    children: React.ReactNode;
    dismissible?: boolean;
    onDismiss?: () => void;
}

export const Alert = ({
    type = 'info',
    title,
    children,
    dismissible = false,
    onDismiss,
}: AlertProps) => {
    return (
        <div className={`${styles.alert} ${styles[`alert-${type}`]}`} role="alert">
            <div className={styles.content}>
                {title && <div className={styles.title}>{title}</div>}
                <div className={styles.message}>{children}</div>
            </div>
            {dismissible && onDismiss && (
                <button
                    className={styles.dismissButton}
                    onClick={onDismiss}
                    aria-label="Cerrar alerta"
                >
                    <X size={16} />
                </button>
            )}
        </div>
    );
};
